import { Button } from '@cmctechnology/phoenix-stockbroking-web-design';
import styled from 'styled-components';

export const CenteredButton = styled(Button)`
  margin-left: auto;
  margin-right: auto;
`;
